import { NVButton } from '@nv/basic-components'
import { Colon } from '@nv/components'
import { useVoterUserContext } from '@nv/contexts'
import QrCodeIcon from '@nv/images/design/qr-code-icon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './VoterMyAccount.module.scss'

export const VoterMyAccount = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const VoterUser = useVoterUserContext().voterUser

  return (
    <>
      <div className={styles['container']}>
        <h1 className={styles['header']}>{t('pages.myAccount')}</h1>

        <div className={styles['body']}>
          {/* USERNAME SECTION */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>{t('auth.login.labels.username.voter')}:</div>
            <div className={styles['body__details__text']}>{VoterUser?.username}</div>
          </div>

          {/* PASSWORD SECTION */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>{t('auth.login.labels.password')}</div>
            <div className={styles['body__details__action-container']}>
              <div className={styles['body__details__text']}>******</div>
              <NVButton variant='text' onClick={() => navigate('/voting/voter/change-password')} text={t('buttons.change')} />
            </div>
          </div>

          {/* REGISTERED PHONE NUMBER */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>
              {t('form.labels.registeredPhone')}
              <Colon />
            </div>
            <div className={styles['body__details__text']}>{VoterUser?.phoneNumber}</div>
          </div>

          {/* QR CODE */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__qr-btn']}>
              <NVButton variant='text' onClick={() => navigate('/voting/voter/change-qr-code')} text={t('auth.qrCode.regen')} />
            </div>
            <div className={styles['body__details__qr-banner']}>
              <QrCodeIcon className={styles['body__details__qr-icon']} />
              <div className={styles['body__details__text']}>{t('auth.qrCode.scanQRrequired')}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
